export default class Network {
  static postLogin(username, password) {
    return sendFetch('/account-management/v1/userauthentication', { userName: username, userPassword: password });
  }

  static postResetRequest(email, language, redirect) {
    return sendFetch('/account-management/v1/passwordreset/init', { email: email, languageCode: language, redirect: redirect });
  }

  static postResetPassword(password, token, id, languageCode) {
    return sendFetch('/account-management/v1/passwordreset/process',
      { newPassword: password, resetHash: token, userId: id, languageCode: languageCode });
  }

  static postChangePassword(oldPassword, newPassword, jwt) {
    const url = '/userpassword?JWT=' + jwt;
    return sendFetch(url, { oldPassword: oldPassword, newPassword: newPassword });
  }
}

function sendFetch(url, body) {
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
  .then(response => response.json());
}